import React, { useState } from 'react';
import { supabase } from '../lib/supabase';

export default function ZmenaHesla({ onClose }) {
  const [noveHeslo, setNoveHeslo] = useState('');
  const [noveHeslo2, setNoveHeslo2] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [ok, setOk] = useState(false);

  const prelozChybu = (msg) => {
    if (!msg) return 'Nastala neznámá chyba. Zkuste to prosím znovu.';
    const m = msg.toLowerCase();
    if (m.includes('password should be at least')) return 'Heslo musí mít alespoň 6 znaků.';
    if (m.includes('same password')) return 'Nové heslo musí být jiné než současné.';
    if (m.includes('session') || m.includes('auth session missing')) return 'Platnost odkazu vypršela. Požádejte o nový odkaz pro reset hesla.';
    if (m.includes('token')) return 'Odkaz je neplatný nebo vypršel. Požádejte o nový.';
    if (m.includes('network') || m.includes('fetch')) return 'Problém se připojením. Zkontrolujte internet a zkuste znovu.';
    return `Chyba: ${msg}`;
  };

  const handleSave = async () => {
    setError('');

    if (noveHeslo.length < 6) {
      setError('Heslo musí mít alespoň 6 znaků.');
      return;
    }
    if (noveHeslo !== noveHeslo2) {
      setError('Hesla se neshodují.');
      return;
    }

    setSaving(true);

    try {
      // Nejdřív zkusíme nastavit session z hash pokud ještě není
      const hash = window.location.hash;
      if (hash && hash.includes('access_token')) {
        const params = new URLSearchParams(hash.substring(1));
        const accessToken = params.get('access_token');
        const refreshToken = params.get('refresh_token');
        if (accessToken && refreshToken) {
          await supabase.auth.setSession({
            access_token: accessToken,
            refresh_token: refreshToken,
          });
        }
      }

      // Teď nastavíme heslo
      const { error: err } = await supabase.auth.updateUser({ password: noveHeslo });

      if (err) {
        setError(prelozChybu(err.message));
        setSaving(false);
        return;
      }

      setOk(true);
      setSaving(false);
      window.history.replaceState(null, '', window.location.pathname);
      setTimeout(() => onClose(), 2500);

    } catch (e) {
      setError(prelozChybu(e?.message));
      setSaving(false);
    }
  };

  const inputStyle = {
    border: '1.5px solid #e2e8f0',
    borderRadius: 10,
    padding: '12px 14px',
    fontSize: 16,
    fontFamily: 'DM Sans, sans-serif',
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
  };

  const silneHeslo = noveHeslo.length >= 6;
  const shoduji = noveHeslo === noveHeslo2 && noveHeslo2.length > 0;

  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: 'rgba(0,0,0,0.65)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, padding: 20, boxSizing: 'border-box',
    }}>
      <div style={{
        background: '#fff', borderRadius: 16, padding: 28,
        width: '100%', maxWidth: 420, boxSizing: 'border-box',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        fontFamily: 'DM Sans, sans-serif',
      }}>
        <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8, color: '#111' }}>
          🔑 Nastavení hesla
        </h3>
        <p style={{ fontSize: 13, color: '#888', marginBottom: 24 }}>
          Zvolte si heslo pro přihlášení do aplikace.
        </p>

        {ok && (
          <div style={{ background: '#d8f3dc', color: '#1b4332', borderRadius: 8, padding: '12px 14px', fontSize: 14, fontWeight: 600, marginBottom: 16 }}>
            ✓ Heslo bylo úspěšně nastaveno. Přihlašujete se…
          </div>
        )}
        {error && (
          <div style={{ background: '#fde8e6', color: '#c0392b', borderRadius: 8, padding: '12px 14px', fontSize: 13, marginBottom: 16 }}>
            ⚠️ {error}
          </div>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>
              Nové heslo
              <span style={{ fontWeight: 400, color: '#aaa', marginLeft: 6 }}>(min. 6 znaků)</span>
            </label>
            <input
              type="password"
              value={noveHeslo}
              onChange={e => setNoveHeslo(e.target.value)}
              placeholder="Zadejte heslo"
              style={{ ...inputStyle, borderColor: noveHeslo.length === 0 ? '#e2e8f0' : silneHeslo ? '#2d6a4f' : '#f59e0b' }}
            />
            {noveHeslo.length > 0 && !silneHeslo && <span style={{ fontSize: 12, color: '#f59e0b' }}>⚠ Min. 6 znaků</span>}
            {silneHeslo && <span style={{ fontSize: 12, color: '#2d6a4f' }}>✓ Délka hesla je v pořádku</span>}
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>Heslo znovu</label>
            <input
              type="password"
              value={noveHeslo2}
              onChange={e => setNoveHeslo2(e.target.value)}
              placeholder="Zopakujte heslo"
              style={{ ...inputStyle, borderColor: noveHeslo2.length === 0 ? '#e2e8f0' : shoduji ? '#2d6a4f' : '#c0392b' }}
            />
            {noveHeslo2.length > 0 && !shoduji && <span style={{ fontSize: 12, color: '#c0392b' }}>✗ Hesla se neshodují</span>}
            {shoduji && <span style={{ fontSize: 12, color: '#2d6a4f' }}>✓ Hesla se shodují</span>}
          </div>
        </div>

        <div style={{ display: 'flex', gap: 10, marginTop: 24 }}>
          <button onClick={onClose} style={{ flex: 1, background: '#f1f5f9', border: 'none', borderRadius: 10, padding: 14, fontSize: 15, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif', fontWeight: 600, color: '#555' }}>
            Zrušit
          </button>
          <button
            onClick={handleSave}
            disabled={saving || ok || !silneHeslo || !shoduji}
            style={{
              flex: 2, background: '#2d6a4f', color: '#fff', border: 'none',
              borderRadius: 10, padding: 14, fontSize: 15,
              cursor: (saving || !silneHeslo || !shoduji) ? 'not-allowed' : 'pointer',
              fontFamily: 'DM Sans, sans-serif', fontWeight: 700,
              opacity: (saving || !silneHeslo || !shoduji) ? 0.5 : 1
            }}
          >
            {saving ? 'Ukládám…' : 'Nastavit heslo'}
          </button>
        </div>
      </div>
    </div>
  );
}
